import { render } from "./CustomerInfoForm.vue?vue&type=template&id=720b07ee&scoped=true"
import script from "./CustomerInfoForm.vue?vue&type=script&lang=js"
export * from "./CustomerInfoForm.vue?vue&type=script&lang=js"

import "./CustomerInfoForm.vue?vue&type=style&index=0&id=720b07ee&lang=scss"
import "./CustomerInfoForm.vue?vue&type=style&index=1&id=720b07ee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720b07ee"]])

export default __exports__